export default {
  today: 'Heute',
};
